import { isReportMockEnabled } from "@/entities/report/api/reportMock";

/** O report-service só aceita o token com `platformAdmin`; com o mock, local e staging entram sem ele. */
export function canAccessPlatformReports(isPlatformAdmin: boolean): boolean {
    return isPlatformAdmin || isReportMockEnabled();
}
